import { loadStripe } from '@stripe/stripe-js/pure';

const loaded = new Map();

export function stripeFor(publishableKey) {
  if (!loaded.has(publishableKey)) {
    const loading = loadStripe(publishableKey).catch((error) => {
      loaded.delete(publishableKey);
      throw error;
    });
    loaded.set(publishableKey, loading);
  }
  return loaded.get(publishableKey);
}

export function stripeError(error) {
  return Object.assign(new Error(error.message || ''), { type: error.type, code: error.code });
}
